<template>
  <div class="myCenter modelPage formStyle">
    <navbar :nav="nav"></navbar>
    <div class="editUserPwd">
      <div class="loginForm mtop10" style="margin-top: 0;">
        <van-form class="loginFormBox">
          <div>古いパスワード</div>
          <van-field
            class="fontStyle"
            v-model="form.pwd"
            placeholder="古いパスワードを入力してください"
            :type="passwordType"
            maxlength="12"
          >
            <template slot="right-icon">
              <span class="pwdSolts" @click="switchPasswordType">
                <van-icon name="eye" v-if="passwordType === 'password'" />
                <van-icon name="closed-eye" v-else />
              </span> </template
          ></van-field>
          <div>新しいパスワード</div>
          <van-field
            class="fontStyle"
            v-model="form.newPwd"
            placeholder="新しいパスワードを入力してください"
            :type="passwordType1"
            maxlength="12"
          >
            <template slot="right-icon">
              <span class="pwdSolts" @click="switchPasswordType1">
                <van-icon name="eye" v-if="passwordType1 === 'password'" />
                <van-icon name="closed-eye" v-else />
              </span> </template
          ></van-field>
          <div>確認のためもう一度入力</div>
          <van-field
            class="fontStyle"
            v-model="form.newPwd2"
            placeholder="新しいパスワードを入力してください"
            :type="passwordType2"
            maxlength="12"
          >
            <template slot="right-icon">
              <span class="pwdSolts" @click="switchPasswordType2">
                <van-icon name="eye" v-if="passwordType2 === 'password'" />
                <van-icon name="closed-eye" v-else />
              </span> </template
          ></van-field>
        </van-form>
      </div>
      <div class="tips">
        ８文字以上12文字以内の半角英数字、１個以上の大文字必須
      </div>
    </div>
    <van-button
      round
      block
      type="info"
      native-type="submit"
      class="buttonBlue userButton"
      :loading="loading"
      @click="saveUserPwd()"
      >確認</van-button
    >
  </div>
</template>

<script>
import Vue from "vue";
import { Toast } from "vant";

Vue.use(Toast);
import md5 from "js-md5";
import { userInfo, updatePassword } from "@/http/user";
import navbar from "../../components/navbar/index.vue";
export default {
  components: {
    navbar
  },

  data() {
    return {
      nav: {
        back: true,
        title: "パスワード変更",
        chat: false
      },
      form: {
        pwd: "",
        newPwd: "",
        newPwd2: ""
      },
      loading: false,
      passwordType: "password",
      passwordType1: "password",
      passwordType2: "password"
    };
  },
  methods: {
    switchPasswordType() {
      this.passwordType =
        this.passwordType === "password" ? "text" : "password";
    },
    switchPasswordType1() {
      this.passwordType1 =
        this.passwordType1 === "password" ? "text" : "password";
    },
    switchPasswordType2() {
      this.passwordType2 =
        this.passwordType2 === "password" ? "text" : "password";
    },
    saveUserPwd() {
      if (!this.form.pwd || this.form.pwd == "") {
        Toast({
          type: "fail",
          icon: "cross",
          // duration: 0,
          message: "古いパスワードを入力してください"
        });
        return;
      }
      if (!this.form.newPwd || this.form.newPwd == "") {
        Toast({
          type: "fail",
          icon: "cross",
          // duration: 0,
          message: "新しいパスワードを入力してください"
        });
        return;
      }
      let reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,12}$/;
      if (!reg.test(this.form.newPwd)) {
        Toast({
          type: "fail",
          icon: "cross",
          message: "8文字以上12文字以内の半角英数字、１個以上の大文字必須"
        });
        return;
      }
      if (!this.form.newPwd2 || this.form.newPwd2 == "") {
        Toast({
          type: "fail",
          icon: "cross",
          // duration: 0,
          message: "新しいパスワードを入力してください"
        });
        return;
      }
      if (this.form.newPwd != this.form.newPwd2) {
        Toast({
          type: "fail",
          icon: "cross",
          // duration: 0,
          message: "2回のパスワードが一致しません"
        });
        return;
      }
      this.loading = true;
      let params = {
        oldPassword: md5(this.form.pwd),
        newPassword: md5(this.form.newPwd)
      };
      updatePassword(
        "?oldPassword=" +
          md5(this.form.pwd) +
          "&newPassword=" +
          md5(this.form.newPwd)
      ).then(res => {
        let { data, code } = res.data;
        if (code == 200) {
          Toast({
            type: "success",
            // duration: 0,
            message: "変更しました"
          });
          this.loading = false;
          localStorage.removeItem("token");
          setTimeout(() => {
            this.$router.push({ path: `/login` });
          }, 1000);
        } else {
          Toast({
            type: "fail",
            icon: "cross",
            message: res.data.msg
          });
          this.loading = false;
        }
      });
    }
  }
};
</script>

<style src="@/assets/css/mycenter.css" scoped></style>
<style src="@/assets/css/form.css" scoped></style>
<style>
.fontStyle input {
  font-size: 14px;
  font-family: RegularFont;
}
.fontStyle input::input-placeholder {
  font-size: 14px;
  color: rgb(35, 32, 54, 0.3);
  font-family: RegularFont;
}
.fontStyle input::-webkit-input-placeholder {
  font-size: 14px;
  color: rgb(35, 32, 54, 0.3);
  font-family: RegularFont;
}
.fontStyle input::-moz-placeholder {
  font-size: 14px;
  color: rgb(35, 32, 54, 0.3);
  font-family: RegularFont;
}
.fontStyle input::-moz-placeholder {
  font-size: 14px;
  color: rgb(35, 32, 54, 0.3);
  font-family: RegularFont;
}
.fontStyle input::-ms-input-placeholder {
  font-size: 14px;
  color: rgb(35, 32, 54, 0.3);
  font-family: RegularFont;
}
.myCenter .editUserPwd .tips {
  font-family: RegularFont;
  font-size: 14px;
  font-weight: normal;
  line-height: 22px;
  color: rgb(35, 32, 54, 0.5);
  width: calc(100% - 48px);
  margin: 10px auto;
}
@media screen and (min-width: 1439px) {
  .fontStyle input {
    font-size: 14px; /* no*/
  }
  .fontStyle input::input-placeholder {
    font-size: 14px; /* no*/
  }
  .fontStyle input::-webkit-input-placeholder {
    font-size: 14px; /* no*/
  }
  .fontStyle input::-moz-placeholder {
    font-size: 14px; /* no*/
  }
  .fontStyle input::-moz-placeholder {
    font-size: 14px; /* no*/
  }
  .fontStyle input::-ms-input-placeholder {
    font-size: 14px; /* no*/
  }
  .myCenter .editUserPwd .tips {
    font-size: 14px; /* no*/
    line-height: 22px; /* no*/
    width: calc(100% - 48px); /* no*/
    margin: 10px auto; /* no*/
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/myCenter/editUserPwd.vue